// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"179":"5a392a8d","246":"276b0af2","253":"57855369","640":"11df1345","745":"ccec2051","822":"1f7dc5cb"}[chunkId] + ".css";
};